import { render, staticRenderFns } from "./c-financial-card-abyl.vue?vue&type=template&id=56d8285c&scoped=true"
import script from "./c-financial-card-abyl.vue?vue&type=script&lang=js"
export * from "./c-financial-card-abyl.vue?vue&type=script&lang=js"
import style0 from "./c-financial-card-abyl.vue?vue&type=style&index=0&id=56d8285c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8285c",
  null
  
)

export default component.exports